import { v4 as uuid } from 'uuid';
import type { PlanumColor } from '@ast-data/shared';

/** A colour row in the editor — a PlanumColor plus a stable local key. */
export type ColorRow = { id: string; color: string; munsellCode: string };

/** Wrap stored colours as editor rows (on open / reset). */
export function toColorRows(
    colors: readonly PlanumColor[] | undefined
): ColorRow[] {
    return (colors ?? []).map((entry) => ({ id: uuid(), ...entry }));
}

/** Strip the local key + empty rows, leaving the storable {color, munsellCode}[]. */
export function cleanColors(rows: readonly ColorRow[]): PlanumColor[] {
    return rows
        .map((row) => ({
            color: row.color.trim(),
            munsellCode: row.munsellCode.trim()
        }))
        .filter((entry) => entry.color !== '' || entry.munsellCode !== '');
}

/** Stable, order-sensitive key for the colour list (dirty comparison). */
export function colorsKey(
    rows: readonly { color: string; munsellCode: string }[]
): string {
    return JSON.stringify(
        rows.map((row) => [row.color.trim(), row.munsellCode.trim()])
    );
}
